function escapeHtml(value) {
  return String(value !== null && value !== void 0 ? value : '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function sourceLabel(source) {
  if (source === 'environment') {
    return 'server environment';
  }
  if (source === 'wallet') {
    return 'server wallet';
  }
  return 'unavailable';
}
module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$configured = _ref.configured,
    configured = _ref$configured === void 0 ? false : _ref$configured,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$source = _ref.source,
    source = _ref$source === void 0 ? '' : _ref$source,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? null : _ref$config,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? '' : _ref$error,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$saving = _ref.saving,
    saving = _ref$saving === void 0 ? false : _ref$saving,
    _ref$configText = _ref.configText,
    configText = _ref$configText === void 0 ? '' : _ref$configText;
  var disabled = saving ? 'disabled' : '';
  var body = loading ? '<p class="admin-payments-empty">Loading Sendgrid settings…</p>' : configured ? "<p class=\"admin-payments-note\">".concat(active ? 'Mail relay is active on this server.' : 'Sendgrid is configured. Mail relay is not yet advertised by this server.', "</p>\n        <p class=\"admin-payments-note\">Source: ").concat(escapeHtml(sourceLabel(source)), "</p>\n        <label for=\"admin-sendgrid-live\">Live configuration</label>\n        <textarea class=\"admin-input admin-payments-backup\" id=\"admin-sendgrid-live\" readonly rows=\"8\">").concat(escapeHtml(JSON.stringify(config || {}, null, 2)), "</textarea>") : "<div class=\"admin-payments-setup\">\n          <p class=\"admin-payments-note\">Configure Sendgrid: </p>\n          <textarea class=\"admin-input admin-payments-backup\" id=\"admin-sendgrid-config\" rows=\"8\" ".concat(disabled, ">").concat(escapeHtml(configText || ''), "</textarea>\n          <button type=\"button\" class=\"admin-button\" id=\"admin-sendgrid-submit\" ").concat(disabled, ">Submit</button>\n        </div>");
  return "\n    <div>\n      <h1>Sendgrid</h1>\n      ".concat(error ? "<div class=\"admin-payments-error\">".concat(escapeHtml(error), "</div>") : '', "\n      ").concat(body, "\n    </div>\n  ");
};